import { render, staticRenderFns } from "./receive.vue?vue&type=template&id=59c6f83c&scoped=true&"
import script from "./receive.vue?vue&type=script&lang=js&"
export * from "./receive.vue?vue&type=script&lang=js&"
import style0 from "./receive.vue?vue&type=style&index=0&id=59c6f83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c6f83c",
  null
  
)

export default component.exports